import $ from 'jquery';
/*
// import 'jquery/src/core/init';
import 'jquery/src/manipulation';
import 'jquery/src/selector';
import 'jquery/src/css';
import 'jquery/src/attributes';
import 'jquery/src/data';
import 'jquery/src/dimensions';
import 'jquery/src/event';
import 'jquery/src/offset';
import 'jquery/src/serialize';
import 'jquery/src/traversing';
*/

$.fn.serializeObject = function()
{
  'use strict';
  var o = {};
  var a = this.serializeArray();
  $.each(a, function() {

    var name = this.name.replace('[]', '');

    if (this.name.indexOf('[]') >= 0 && !o[name]) {
      o[name] = [];
    }

    if (o[name] !== undefined) {
      if (!o[name].push) {
        o[name] = [o[name]];
      }
      o[name].push(this.value || '');
    } else {
      o[name] = this.value || '';
    }
  });
  return o;
};

$.fn.hScroll = function (amount) {
  amount = amount || 120;
  $(this).bind('DOMMouseScroll mousewheel', function (event) {

    var originalEvent = event.originalEvent,
      isTouchPad = originalEvent.wheelDeltaY ? originalEvent.wheelDeltaY === -3 * originalEvent.deltaY : originalEvent.deltaMode === 0,
      x = originalEvent.layerX,
      wrapper = $(originalEvent.target).closest('.table-wrapper'),
      wrapperHalfWidth = wrapper.outerWidth() / 2,
      isVerticalScrolling = x <= wrapperHalfWidth,
      direction = originalEvent.detail ? originalEvent.detail * -amount : originalEvent.wheelDelta,
      position = $(this).scrollLeft();

    if (!isVerticalScrolling && !isTouchPad) {
      position += direction > 0 ? -amount : amount;
      $(this).scrollLeft(position);
      event.preventDefault();
    }

  })
};

$.urlParam = function(name, url) {
  if (!url) {
    url = window.location.href;
  }
  var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url);
  if (!results) {
    return undefined;
  }
  return results[1] || undefined;
};

$.getHashParams = function() {

  var hashParams = {};
  var e,
    a = /\+/g,  // Regex for replacing addition symbol with a space
    r = /([^&;=]+)=?([^&;]*)/g,
    d = function (s) { return decodeURIComponent(s.replace(a, ' ')); },
    q = window.location.hash.substring(1);

  while (e = r.exec(q))
    hashParams[d(e[1])] = d(e[2]);

  return hashParams;

};

$.snakeToCamelCase = function(str){
  return str.replace(/^_/, '').replace('[', '_').replace(']', '').replace(/_(\w)/g, function(m){ return m[1].toUpperCase() });
};

$.extend($.easing,
  {
    easeInOutQuad: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t + b;
      return -c/2 * ((--t)*(t-2) - 1) + b;
    }
});

$.fn.getPath = function () {
  if (this.length !== 1) throw 'Requires one element.';

  let path, node = this;
  while (node.length) {
    let realNode = node[0], name = realNode.localName;
    if (!name) break;
    name = name.toLowerCase();

    let parent = node.parent();

    let siblings = parent.children(name);
    if (siblings.length > 1) {
      name += ':eq(' + siblings.index(realNode) + ')';
    }

    path = name + (path ? '>' + path : '');
    node = parent;
  }

  return path;
};

export default $;